export default __webpack_public_path__ + "static/media/courseBg3.09e319ef.png";